(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9342],{

/***/ 59258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Header; }
});

// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(11527);
// EXTERNAL MODULE: ./node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(50959);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/link.js
var next_link = __webpack_require__(6339);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./containers/layout/header/header.module.scss
var header_module = __webpack_require__(34710);
var header_module_default = /*#__PURE__*/__webpack_require__.n(header_module);
// EXTERNAL MODULE: ./components/icons.tsx
var icons = __webpack_require__(17312);
// EXTERNAL MODULE: ./contexts/theme/theme.context.tsx
var theme_context = __webpack_require__(81803);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/dynamic.js
var dynamic = __webpack_require__(34131);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./containers/searchContainer/searchContainer.module.scss
var searchContainer_module = __webpack_require__(52221);
var searchContainer_module_default = /*#__PURE__*/__webpack_require__.n(searchContainer_module);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-i18next@12.3.1_i18next@22.5.1_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-i18next/dist/es/index.js + 17 modules
var es = __webpack_require__(53218);
// EXTERNAL MODULE: ./hooks/useDebounce.tsx
var useDebounce = __webpack_require__(57812);
// EXTERNAL MODULE: ./hooks/useDidUpdate.tsx
var useDidUpdate = __webpack_require__(24162);
// EXTERNAL MODULE: ./node_modules/.pnpm/react-query@3.39.3_react-dom@18.2.0_react@18.2.0__react@18.2.0/node_modules/react-query/es/index.js
var react_query_es = __webpack_require__(49532);
// EXTERNAL MODULE: ./services/shop.ts
var shop = __webpack_require__(67788);
// EXTERNAL MODULE: ./services/product.ts
var product = __webpack_require__(78564);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/router.js
var router = __webpack_require__(21867);
// EXTERNAL MODULE: ./hooks/useUserLocation.tsx
var useUserLocation = __webpack_require__(52664);
// EXTERNAL MODULE: ./hooks/useRedux.tsx
var useRedux = __webpack_require__(46496);
// EXTERNAL MODULE: ./redux/slices/search.ts
var search = __webpack_require__(92184);
// EXTERNAL MODULE: ./constants/config.ts
var config = __webpack_require__(66750);
// EXTERNAL MODULE: ./contexts/settings/settings.context.tsx
var settings_context = __webpack_require__(8854);
;// CONCATENATED MODULE: ./containers/searchContainer/searchContainer.tsx
















const PopoverContainer = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9134), __webpack_require__.e(8), __webpack_require__.e(704)]).then(__webpack_require__.bind(__webpack_require__, 71048)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(71048)
            ]
    }
});
const SearchResult = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(2709), __webpack_require__.e(6637)]).then(__webpack_require__.bind(__webpack_require__, 86637)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(86637)
            ]
    }
});
const SearchSuggestions = dynamic_default()(()=>__webpack_require__.e(/* import() */ 9571).then(__webpack_require__.bind(__webpack_require__, 49571)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(49571)
            ]
    }
});
const shopRoutes = [
    "shop/"
];
function SearchContainer(param) {
    let { searchContainerRef  } = param;
    var ref, ref1;
    const { t , i18n  } = (0,es/* useTranslation */.$G)();
    const locale = i18n.language;
    const { settings  } = (0,settings_context/* useSettings */.r)();
    const [searchTerm, setSearchTerm] = (0,react.useState)("");
    const debouncedSearchTerm = (0,useDebounce/* default */.Z)(searchTerm.trim(), 400);
    const [anchorEl, setAnchorEl] = (0,react.useState)(null);
    const open = Boolean(anchorEl);
    const [anchorSuggestion, setAnchorSuggestion] = (0,react.useState)(null);
    const openSuggestion = Boolean(anchorSuggestion);
    const { pathname , query  } = (0,router.useRouter)();
    const isRestaurantRoute = shopRoutes.some((item)=>pathname.includes(item));
    const location = (0,useUserLocation/* default */.Z)();
    const dispatch = (0,useRedux/* useAppDispatch */.T)();
    const history = (0,useRedux/* useAppSelector */.C)(search/* selectSearchHistory */.ag);
    const { data: shops , fetchNextPage: fetchShopsNextPage , hasNextPage: hasShopsNextPage , isFetchingNextPage: isFetchingShopsNextPage , isLoading: isShopsLoading  } = (0,react_query_es.useInfiniteQuery)([
        "shopResult",
        debouncedSearchTerm,
        location,
        locale
    ], (param)=>{
        let { pageParam =1  } = param;
        return shop/* default.search */.Z.search({
            search: debouncedSearchTerm,
            page: pageParam,
            address: location,
            open: 1
        });
    }, {
        getNextPageParam: (lastPage)=>{
            if (lastPage.meta.current_page < lastPage.meta.last_page) {
                return lastPage.meta.current_page + 1;
            }
            return undefined;
        },
        retry: false,
        enabled: !!debouncedSearchTerm && !isRestaurantRoute
    });
    const { data: products , fetchNextPage: fetchProductsNextPage , hasNextPage: hasProductsNextPage , isFetchingNextPage: isFetchingProductsNextPage , isLoading: isProductsLoading  } = (0,react_query_es.useInfiniteQuery)([
        "productResult",
        debouncedSearchTerm,
        locale
    ], (param)=>{
        let { pageParam =1  } = param;
        return product/* default.search */.Z.search({
            search: debouncedSearchTerm,
            page: pageParam,
            shop_id: isRestaurantRoute ? query.id : undefined,
            address: location
        });
    }, {
        getNextPageParam: (lastPage)=>{
            if (lastPage.meta.current_page < lastPage.meta.last_page) {
                return lastPage.meta.current_page + 1;
            }
            return undefined;
        },
        retry: false,
        enabled: !!debouncedSearchTerm,
        onSuccess: ()=>{
            dispatch((0,search/* addToSearch */.fy)(debouncedSearchTerm));
        }
    });
    const handleOpen = ()=>setAnchorEl(searchContainerRef.current);
    const handleClose = ()=>setAnchorEl(null);
    const handleOpenSuggestion = ()=>setAnchorSuggestion(searchContainerRef.current);
    const handleCloseSuggestion = ()=>setAnchorSuggestion(null);
    const handleClick = ()=>{
        handleOpenSuggestion();
        if (debouncedSearchTerm) {
            handleOpen();
            handleCloseSuggestion();
        }
    };
    (0,useDidUpdate/* default */.Z)(()=>{
        if (debouncedSearchTerm) {
            handleOpen();
            handleCloseSuggestion();
        } else {
            handleClose();
            handleOpenSuggestion();
        }
    }, [
        debouncedSearchTerm
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (searchContainer_module_default()).search,
        ref: searchContainerRef,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                type: "text",
                id: "search",
                placeholder: "".concat(t(isRestaurantRoute ? "search.in" : "search.on"), " ").concat(isRestaurantRoute ? t("this.shop") : (settings === null || settings === void 0 ? void 0 : settings.title) || config/* META_TITLE */.k5),
                autoComplete: "off",
                value: searchTerm,
                onChange: (event)=>setSearchTerm(event.target.value),
                onClick: handleClick
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverContainer, {
                open: open,
                anchorEl: anchorEl,
                onClose: handleClose,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                },
                anchorPosition: {
                    left: 30,
                    top: 30
                },
                disableAutoFocus: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchResult, {
                    isVisibleShops: !isRestaurantRoute,
                    shops: (shops === null || shops === void 0 ? void 0 : (ref = shops.pages) === null || ref === void 0 ? void 0 : ref.flatMap((item)=>item.data)) || [],
                    products: (products === null || products === void 0 ? void 0 : (ref1 = products.pages) === null || ref1 === void 0 ? void 0 : ref1.flatMap((item)=>item.data)) || [],
                    isLoading: isShopsLoading || isProductsLoading,
                    handleClickItem: handleClose,
                    productTotal: (products === null || products === void 0 ? void 0 : products.pages) ? products.pages[0].meta.total : 0,
                    shopTotal: (shops === null || shops === void 0 ? void 0 : shops.pages) ? shops.pages[0].meta.total : 0,
                    isFetchingShopsNextPage: isFetchingShopsNextPage,
                    isFetchingProductsNextPage: isFetchingProductsNextPage,
                    hasProductsNextPage: !!hasProductsNextPage,
                    hasShopsNextPage: !!hasShopsNextPage,
                    fetchProductsNextPage: fetchProductsNextPage,
                    fetchShopsNextPage: fetchShopsNextPage
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PopoverContainer, {
                open: openSuggestion && !!history.length,
                anchorEl: anchorSuggestion,
                onClose: handleCloseSuggestion,
                anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left"
                },
                anchorPosition: {
                    left: 30,
                    top: 30
                },
                disableAutoFocus: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchSuggestions, {
                    setSearchTerm: setSearchTerm
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./contexts/auth/auth.context.tsx
var auth_context = __webpack_require__(77712);
// EXTERNAL MODULE: ./hooks/useModal.tsx
var useModal = __webpack_require__(68864);
// EXTERNAL MODULE: ./containers/addressContainer/addressContainer.tsx
var addressContainer = __webpack_require__(41679);
// EXTERNAL MODULE: ./node_modules/.pnpm/next@13.0.0_react-dom@18.2.0_react@18.2.0__react@18.2.0_sass@1.99.0/node_modules/next/image.js
var next_image = __webpack_require__(86430);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./components/cartButton/cartButton.tsx
var cartButton = __webpack_require__(40064);
// EXTERNAL MODULE: ./components/notificationStats/notificationStats.tsx
var notificationStats = __webpack_require__(77399);
;// CONCATENATED MODULE: ./containers/layout/header/header.tsx
















const AppDrawer = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9134), __webpack_require__.e(1680), __webpack_require__.e(3651), __webpack_require__.e(3990)]).then(__webpack_require__.bind(__webpack_require__, 3990)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(3990)
            ]
    }
});
const ProfileDropdown = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(9134), __webpack_require__.e(8), __webpack_require__.e(3651), __webpack_require__.e(8324)]).then(__webpack_require__.bind(__webpack_require__, 58324)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(58324)
            ]
    }
});
function Header() {
    const { t  } = (0,es/* useTranslation */.$G)();
    const { pathname  } = (0,router.useRouter)();
    const { isDarkMode  } = (0,react.useContext)(theme_context/* ThemeContext */.N);
    const { isAuthenticated , user , openAuthModal  } = (0,auth_context/* useAuth */.a)();
    const [appDrawer, handleOpenAppDrawer, handleCloseAppDrawer] = (0,useModal/* default */.Z)();
    const searchContainerRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "".concat((header_module_default()).container, " ").concat(pathname !== "/" && (header_module_default()).bordered),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("header", {
                    className: (header_module_default()).header,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (header_module_default()).navItem,
                            children: [
                                !isAuthenticated && /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                    className: (header_module_default()).menuBtn,
                                    onClick: handleOpenAppDrawer,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        src: "/images/menu.svg",
                                        alt: "menu",
                                        width: 20,
                                        height: 20
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: "/",
                                    className: (header_module_default()).brandLogo,
                                    children: isDarkMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* BrandLogoDark */.$C, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* BrandLogo */.Oc, {})
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "".concat((header_module_default()).navItem, " ").concat((header_module_default()).searchBar),
                            ref: searchContainerRef,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (header_module_default()).search,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchContainer, {
                                    searchContainerRef: searchContainerRef
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (header_module_default()).navItem,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(addressContainer/* default */.Z, {})
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(notificationStats/* default */.Z, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (header_module_default()).navItem,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cartButton/* default */.Z, {})
                        }),
                        isAuthenticated ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProfileDropdown, {
                            data: user
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                            type: "button",
                            onClick: openAuthModal,
                            className: (header_module_default()).login,
                            children: t("login")
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AppDrawer, {
                open: appDrawer,
                handleClose: handleCloseAppDrawer
            })
        ]
    });
}


/***/ }),

/***/ 57812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useDebounce; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

function useDebounce(value, delay) {
    const [debounceValue, setDebounceValue] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(value);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const timer = setTimeout(()=>{
            setDebounceValue(value);
        }, delay);
        return ()=>{
            clearTimeout(timer);
        };
    }, [
        value,
        delay
    ]);
    return debounceValue;
}


/***/ }),

/***/ 24162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);

const useDidUpdate = (f, conditions)=>{
    const didMountRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!didMountRef.current) {
            didMountRef.current = true;
            return;
        }
        // Cleanup effects when f returns a function
        return f && f(); //eslint-disable-line
    }, conditions);
};
/* harmony default export */ __webpack_exports__["Z"] = (useDidUpdate);


/***/ }),

/***/ 52664:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useUserLocation; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(50959);
/* harmony import */ var contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8854);


function useUserLocation() {
    const { location: userLocation  } = (0,contexts_settings_settings_context__WEBPACK_IMPORTED_MODULE_1__/* .useSettings */ .r)();
    const location = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        const latlng = userLocation;
        if (!latlng) {
            return undefined;
        }
        return {
            latitude: latlng.split(",")[0],
            longitude: latlng.split(",")[1]
        };
    }, [
        userLocation
    ]);
    return location;
}


/***/ }),

/***/ 78564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47137);

const productService = {
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/paginate", {
            params
        }),
    getAllShopProducts: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/".concat(id, "/products"), {
            params
        }),
    getById: (uuid, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/".concat(uuid), {
            params
        }),
    search: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/search", {
            params
        }),
    getByIds: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/products/ids", {
            params
        }),
    getViewed: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/product-histories/paginate", {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (productService);


/***/ }),

/***/ 67788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _request__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47137);

const shopService = {
    getAll: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/paginate?".concat(params)),
    getAllBooking: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/booking/shops/paginate?".concat(params)),
    getAllRestaurants: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/paginate?type=restaurant&".concat(params)),
    getAllShops: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/paginate?type=shop&".concat(params)),
    getById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/".concat(id), {
            params
        }),
    search: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/search", {
            params
        }),
    getAllTags: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops-takes", {
            params
        }),
    create: (data)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].post */ .Z.post("/dashboard/user/shops", data),
    checkZone: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shop/delivery-zone/check/distance", {
            params
        }),
    checkZoneById: (id, params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shop/".concat(id, "/delivery-zone/check/distance"), {
            params
        }),
    getVisitedShops: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops-histories/paginate", {
            params
        }),
    getByIds: (params)=>_request__WEBPACK_IMPORTED_MODULE_0__/* ["default"].get */ .Z.get("/rest/shops/ids", {
            params
        })
};
/* harmony default export */ __webpack_exports__["Z"] = (shopService);


/***/ }),

/***/ 34710:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"header_container__EWEDv","bordered":"header_bordered__qCmHl","header":"header_header__SAJHp","navItem":"header_navItem__7Y6f4","brandLogo":"header_brandLogo__A0_aV","menuBtn":"header_menuBtn__Vexr0","search":"header_search__EipNy","searchBar":"header_searchBar__kGcPB","actions":"header_actions__rbgla","iconBtn":"header_iconBtn__Is3SD","login":"header_login__moAd5"};

/***/ }),

/***/ 52221:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search":"searchContainer_search__Z8MFl"};

/***/ })

}]);